import { isAxiosError, AxiosError } from 'axios';

export class ClientError extends Error { }

export class Unauthorized extends ClientError {}

export class BadRequest extends ClientError { }

export class NotFound extends Error {}

export class ServerError extends Error {}


export type ValidationErrorFields<T> = {
  [K in keyof T]?: T[K] extends object ? ValidationErrorFields<T[K]> | string : string;
};


export type ValidationError<Fields> = {
  code: 'validation-error';
  message: string;
  fields: ValidationErrorFields<Fields> & {
    __root?: string;
  };
};


export type ApiError = AxiosError<{
  error: string;
  error_key?: string;
}>;

export const isApiError = isAxiosError;
export const getApiErrorMessage = (error: unknown): string | null => {
  if (isApiError(error)) {
    return (
      error.response?.data.message
      || error.response?.data.error
      || error.message
    );
  }

  return null;
};
